import LegalPersonAdd from './views/legal-person/Add.vue';
import LegalPersonCreate from './views/legal-person/Create.vue';
import LegalPersonEdit from './views/legal-person/Edit.vue';
import LegalPerson from './views/legal-person/Index.vue';
import OthersAdd from './views/others/Add.vue';
import OthersCreate from './views/others/Create.vue';
import OthersEdit from './views/others/Edit.vue';
import Others from './views/others/Index.vue';
import PhysicalPersonAdd from './views/physical-person/Add.vue';
import PhysicalPersonCreate from './views/physical-person/Create.vue';
import PhysicalPersonEdit from './views/physical-person/Edit.vue';
import PhysicalPerson from './views/physical-person/Index.vue';
import PropertyAdd from './views/properties/Add.vue';
import PropertyCreate from './views/properties/Create.vue';
import PropertyEdit from './views/properties/Edit.vue';
import Property from './views/properties/Index.vue';
import VehicleAdd from './views/vehicles/Add.vue';
import VehicleCreate from './views/vehicles/Create.vue';
import VehicleEdit from './views/vehicles/Edit.vue';
import Vehicle from './views/vehicles/Index.vue';

const routes = [
  {
    path: '/template/legal-person/',
    name: 'Template-Legal-Person',
    component: LegalPerson,
  },
  {
    path: '/template/legal-person/:id/add',
    name: 'Template-Legal-Person-Add',
    component: LegalPersonAdd,
  },
  {
    path: '/template/legal-person/:id',
    name: 'Template-Legal-Person-Edit',
    component: LegalPersonEdit,
  },
  {
    path: '/template/legal-person/create',
    name: 'Template-Legal-Person-Create',
    component: LegalPersonCreate,
  },
  {
    path: '/template/physical-person/',
    name: 'Template-Physical-Person',
    component: PhysicalPerson,
  },
  {
    path: '/template/physical-person/:id/add',
    name: 'Template-Physical-Person-Add',
    component: PhysicalPersonAdd,
  },
  {
    path: '/template/physical-person/:id',
    name: 'Template-Physical-Person-Edit',
    component: PhysicalPersonEdit,
  },
  {
    path: '/template/physical-person/create',
    name: 'Template-Physical-Person-Create',
    component: PhysicalPersonCreate,
  },
  {
    path: '/template/vehicles/',
    name: 'Template-Vehicle',
    component: Vehicle,
  },
  {
    path: '/template/vehicles/create',
    name: 'Template-Vehicle-Create',
    component: VehicleCreate,
  },
  {
    path: '/template/vehicles/:id',
    name: 'Template-Vehicle-Edit',
    component: VehicleEdit,
  },
  {
    path: '/template/vehicles/:id/add',
    name: 'Template-Vehicle-Add',
    component: VehicleAdd,
  },
  {
    path: '/template/properties/',
    name: 'Template-Property',
    component: Property,
  },
  {
    path: '/template/properties/create',
    name: 'Template-Property-Create',
    component: PropertyCreate,
  },
  {
    path: '/template/properties/:id',
    name: 'Template-Property-Edit',
    component: PropertyEdit,
  },
  {
    path: '/template/properties/:id/add',
    name: 'Template-Property-Add',
    component: PropertyAdd,
  },
  {
    path: '/template/others/',
    name: 'Template-Other',
    component: Others,
  },
  {
    path: '/template/others/create',
    name: 'Template-Other-Create',
    component: OthersCreate,
  },
  {
    path: '/template/others/:id',
    name: 'Template-Other-Edit',
    component: OthersEdit,
  },
  {
    path: '/template/others/:id/add',
    name: 'Template-Other-Add',
    component: OthersAdd,
  },
];

export default routes;
